import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Download, FileText, Trash2 } from 'lucide-react';

export type EfChatEfAttachmentProps = {
    fileName: string;
    metaLabel?: string;
    onDownload?: () => void;
    downloadLabel?: string;
    onDelete?: () => void;
    deleteLabel?: string;
};

export function EfChatEfAttachment({ fileName, metaLabel, onDownload, downloadLabel, onDelete, deleteLabel }: EfChatEfAttachmentProps) {
    return (
        <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            data-testid="ef-chat-ef-attachment"
            sx={{ display: 'inline-flex', maxWidth: '100%', bgcolor: 'action.hover', border: '1px solid', borderColor: 'divider', borderRadius: 2, pl: 1, pr: 0.5, py: 0.5 }}
        >
            <Box sx={{ display: 'flex', width: 28, height: 28, borderRadius: 1, bgcolor: 'action.selected', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <FileText size={15} style={{ opacity: 0.7 }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: 12.5, fontWeight: 500, lineHeight: 1.2 }} noWrap>
                    {fileName}
                </Typography>
                {metaLabel ? (
                    <Typography sx={{ fontSize: 11, color: 'text.secondary', lineHeight: 1.2 }} noWrap>
                        {metaLabel}
                    </Typography>
                ) : null}
            </Box>
            {onDownload ? (
                <Tooltip title={downloadLabel ?? ''}>
                    <IconButton size="small" onClick={onDownload} aria-label={downloadLabel ?? 'download'} sx={{ flexShrink: 0 }}>
                        <Download size={14} />
                    </IconButton>
                </Tooltip>
            ) : null}
            {onDelete ? (
                <Tooltip title={deleteLabel ?? ''}>
                    <IconButton
                        size="small"
                        color="error"
                        onClick={onDelete}
                        aria-label={deleteLabel ?? 'delete'}
                        data-testid="ef-chat-ef-attachment-delete"
                        sx={{ flexShrink: 0 }}
                    >
                        <Trash2 size={14} />
                    </IconButton>
                </Tooltip>
            ) : null}
        </Stack>
    );
}
